import { useGetCategoriesQuery } from "../../../redux/services/categoriesService/categories.Services";
import { useGetSubCategoriesQuery } from "../../../redux/services/subCategoriesService/subCategories.Services";
import { useGetStateQuery } from "../../../redux/services/stateService/state.Services";
import { useGetCityQuery } from "../../../redux/services/cityService/city.Services";
import { useGetLocationQuery } from "../../../redux/services/locationService/location.Services";
import { useGetAmenitiesQuery } from "../../../redux/services/AmenitiesService/amienities.Services";

export const useProductDropdownData = (formData) => {
  // 📦 Categories
  const { data: categoriesData } = useGetCategoriesQuery();
  const categories = categoriesData?.data || [];
  const { data: subCategoriesData } = useGetSubCategoriesQuery(
    formData?.category_id,
    { skip: !formData?.category_id }
  );
  const subCategories = subCategoriesData?.data || [];
  const { data: statesData } = useGetStateQuery();
  const states = statesData?.data || [];

  // 📦 Cities (depends on state)
  const { data: citiesData } = useGetCityQuery(
    formData?.state_id,
    { skip: !formData?.state_id }
  );
  const cities = citiesData?.data || [];

  // 📦 Locations (depends on city)
  const { data: locationsData } = useGetLocationQuery(
    formData?.city_id,
    { skip: !formData?.city_id }
  );
  const locations = locationsData?.data || [];

  // 📦 Amenities
  const { data: amenitiesData } = useGetAmenitiesQuery();
  const amenities = amenitiesData?.data || [];

  return {
    categories,
    subCategories,
    states,
    cities,
    locations,
    amenities,
  };
};